import * as reactDom from 'react-dom';
import * as React from 'react';

import { ModalState } from '../../../types';
import { MODAL_STATE } from '../../../constants';
import * as S from './styles';

interface PropTypes {
  state: ModalState;
  onClickDimmer?: React.MouseEventHandler<HTMLDivElement>;
  onHiddenEnd?: React.AnimationEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}

function Modal({ state, onClickDimmer, onHiddenEnd, children }: PropTypes) {
  const onAnimationEnd = (event) => {
    if (state === MODAL_STATE.VISIBLE) return;

    onHiddenEnd(event);
  };

  const ModalContainer = (
    <S.Container className={state} onClick={onClickDimmer} onAnimationEnd={onAnimationEnd}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </S.Container>
  );

  const $paymentApp = document.querySelector('#payments-app-container').parentElement;
  return reactDom.createPortal(ModalContainer, $paymentApp);
}

Modal.defaultProps = {
  onClickDimmer: () => {},
  onHiddenEnd: () => {},
};

export default Modal;
